export const formatCurrency = (amount: number, currency: string): string => {
  return Intl.NumberFormat("en-EN", {
    style: "currency",
    currency: currency,
  }).format(amount);
};

export const formatCurrencyCents = (amount: number, currency: string): string =>
  formatCurrency(amount / 100, currency);

export const parseJWT = (token: string) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};
